module.exports = __webpack_public_path__ + "img/banner2.bc084218.png";